var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { transparentize } from 'polished';
import React, { createContext, useContext, useMemo, } from 'react';
import styled from 'styled-components';
import { SAUX360Theme } from '../theme';
import { SAIcon, SAIcons, SAIconSize } from '../icon';
var StepperRoot = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var List = styled.ol(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  list-style-type: none;\n"], ["\n  display: flex;\n  flex-direction: row;\n  list-style-type: none;\n"])));
var Number = styled.div.attrs(function (_a) {
    var colorOverride = _a.colorOverride, disabled = _a.disabled;
    return ({
        colorOverride: colorOverride,
        disabled: disabled,
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var colorOverride = _a.colorOverride, disabled = _a.disabled, theme = _a.theme;
    var background = disabled ? theme.color.disabled.background : theme === null || theme === void 0 ? void 0 : theme.colors[colorOverride];
    return "\n      display: flex;\n      background: " + background + ";\n      color: " + theme.colors.white + ";\n      border-radius: 100%;\n      height: 24px;\n      width: 24px;\n      justify-content: center;\n      align-items: center;\n      margin-right: " + theme.size.spacer.xs + ";\n    ";
});
var Label = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Connector = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      display: flex;\n      padding-right: " + theme.size.spacer.small + ";\n      padding-left: " + theme.size.spacer.small + ";\n    ";
});
var StepRoot = styled.li.attrs(function (_a) {
    var active = _a.active, colorOverride = _a.colorOverride, completed = _a.completed, disabled = _a.disabled;
    return ({
        active: active,
        colorOverride: colorOverride,
        completed: completed,
        disabled: disabled,
    });
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var active = _a.active, colorOverride = _a.colorOverride, completed = _a.completed, disabled = _a.disabled, theme = _a.theme;
    var buttonColor = '';
    var backgroundColor = '';
    var cursor = '';
    if (active) {
        buttonColor = "color: " + (theme === null || theme === void 0 ? void 0 : theme.colors[colorOverride]) + ";";
        backgroundColor = "background-color: " + transparentize(0.95, theme === null || theme === void 0 ? void 0 : theme.colors[colorOverride]) + ";";
    }
    else if (completed) {
        buttonColor = "color: " + theme.color.container.foreground + ";";
        backgroundColor = "background-color: " + transparentize(0.95, theme.colors.text) + ";";
    }
    else if (disabled) {
        buttonColor = "color: " + theme.color.disabled.background + ";";
        cursor = 'cursor: initial;';
    }
    else {
        buttonColor = "color: " + theme.color.container.foreground + ";";
        backgroundColor = "background-color: " + transparentize(0.95, theme.colors.text) + ";";
    }
    return "\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      button {\n        " + buttonColor + "\n        " + cursor + "\n\n        &:hover {\n          " + backgroundColor + "\n        }\n      }\n    ";
});
var StepperContext = createContext({
    connector: undefined,
    hideNumbers: undefined,
});
var StepContext = createContext({});
export function SAStepper(_a) {
    var activeStep = _a.activeStep, children = _a.children, connector = _a.connector, hideNumbers = _a.hideNumbers, label = _a.label, variant = _a.variant, rest = __rest(_a, ["activeStep", "children", "connector", "hideNumbers", "label", "variant"]);
    var childrenArray = React.Children.toArray(children).filter(Boolean);
    var steps = childrenArray.map(function (step, index) {
        var clonedStep = step;
        return React.cloneElement(clonedStep, {
            index: index,
            last: index + 1 === childrenArray.length,
            children: React.cloneElement(clonedStep.props.children, {
                'aria-current': activeStep === index ? 'step' : false,
            }),
        });
    });
    var contextValue = useMemo(function () { return ({ connector: connector, hideNumbers: hideNumbers }); }, [connector, hideNumbers]);
    return (React.createElement(StepperContext.Provider, { value: contextValue },
        React.createElement(StepperRoot, __assign({ "aria-label": label, className: "stepper-root" }, rest),
            React.createElement(List, { className: "stepper" }, steps))));
}
SAStepper.defaultProps = {
    connector: (React.createElement(SAIcon, { icon: SAIcons.arrowRight, size: SAIconSize.medium, colorVariant: SAUX360Theme.color.disabled.background })),
    hideNumbers: false,
    label: 'progress',
    theme: SAUX360Theme,
    variant: undefined,
};
export function SAStep(_a) {
    var active = _a.active, children = _a.children, color = _a.color, completed = _a.completed, disabled = _a.disabled, index = _a.index, last = _a.last, optional = _a.optional, theme = _a.theme, variant = _a.variant, rest = __rest(_a, ["active", "children", "color", "completed", "disabled", "index", "last", "optional", "theme", "variant"]);
    var _b = useContext(StepperContext), connector = _b.connector, hideNumbers = _b.hideNumbers;
    var contextValue = useMemo(function () { return ({ index: index, last: last, active: active, color: color, completed: completed, disabled: disabled, optional: optional }); }, [
        index,
        last,
        active,
        color,
        completed,
        disabled,
        optional,
    ]);
    return (React.createElement(StepContext.Provider, { value: contextValue },
        React.createElement(StepRoot, __assign({ colorOverride: color, className: "stepper-item", active: active, completed: completed, disabled: disabled }, rest),
            connector && index !== 0 ? React.createElement(Connector, null, connector) : null,
            !hideNumbers && !completed && (React.createElement(Number, { disabled: disabled, colorOverride: color }, index + 1)),
            !hideNumbers && completed && (React.createElement(Number, { disabled: disabled, colorOverride: color },
                React.createElement(SAIcon, { icon: SAIcons.checkmark, size: SAIconSize.medium, colorVariant: theme === null || theme === void 0 ? void 0 : theme.colors.white }))),
            React.createElement(Label, null,
                children,
                optional))));
}
SAStep.defaultProps = {
    active: false,
    color: 'accentBlue',
    completed: false,
    disabled: false,
    last: false,
    optional: undefined,
    theme: SAUX360Theme,
    variant: undefined,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=stepper.component.js.map